module.exports = __webpack_public_path__ + "img/2024shnh-1.9678df81.jpg";